<app-alert></app-alert>
<form [formGroup]="uploadFormFile" (ngSubmit)="onSubmit()" class="container form-upload-file">
  <div class="form-header">
    <h1>{{ 'global.support-modal-send-file-title' | translate }}</h1>
  </div>

  @if (!isEditMode) {
    <div class="form-group mb-5">
      <label class="mb-4" for="uploadTarget">{{ 'global.support-upload-target-label' | translate }}</label>
      <div class="tabs" id="uploadTarget">
        <div [class.active]="uploadFormFile.get('uploadTarget')?.value === uploadTargetProduct"
          (click)="uploadFormFile.get('uploadTarget')?.setValue(uploadTargetProduct)">
          {{ 'global.support-upload-target-product' | translate }}
        </div>
        <div [class.active]="uploadFormFile.get('uploadTarget')?.value === informativosDocId"
          (click)="uploadFormFile.get('uploadTarget')?.setValue(informativosDocId)">
          {{ 'global.support-upload-target-informativos' | translate }}
        </div>
      </div>
    </div>
  }

  <p>{{ 'global.support-modal-send-file-text-select-language' | translate }}</p>

  <div class="tabs">
    <div *ngFor="let lang of languages" [class.active]="selectedLanguage === lang.code"
      (click)="setLanguage(lang.code)">
      <img [src]="'./../../../../../assets/images/support-page/flags/' + lang.flag" [alt]="lang" />
    </div>
  </div>

  <div *ngIf="!allLanguagesFilled" class="text-information">
    *{{ 'global.support-fill-name-description' | translate }}
  </div>

  <div [formGroup]="uploadFormFile.get('fileMetadataByLanguage')?.get(selectedLanguage)">
    <div class="mb-5">
      <input type="text" id="fileName" class="form-control" formControlName="fileName" (input)="checkLanguages()"
        placeholder="{{ 'global.support-file-name' | translate }}" />
    </div>

    <div class="mb-5">
      <textarea id="description" class="form-control" formControlName="description" (input)="checkLanguages()"
        placeholder="{{ 'global.support-description' | translate }}" rows="4">
      </textarea>
    </div>
  </div>

  <div class="button-translate-info">
    <button type="button" class="button-translate-info--translate" (click)="translateFields()">
      <i class="agres-action"></i>
      {{ 'global.support-button-translate-names' | translate }}
    </button>
    <div class="tooltip-container">
      <div class="info-icon">i</div>
      <div class="tooltip-text">
        {{ 'global.support-message-translate-names-tooltip' | translate }}
      </div>
    </div>
  </div>

  @if (uploadFormFile.get('productId')?.value !== informativosDocId) {
    <div class="mb-5">
      <input type="text" id="version" class="form-control" formControlName="fileVersion" [ngClass]="{
          'is-invalid': uploadFormFile.get('fileVersion')?.invalid && uploadFormFile.get('fileVersion')?.touched,
        }" placeholder="{{ 'global.support-version' | translate }}" />
      <div *ngIf="uploadFormFile.get('fileVersion')?.invalid && uploadFormFile.get('fileVersion')?.touched"
        class="invalid-feedback">
        {{ 'global.support-version-msg-mandatory' | translate }}
      </div>
    </div>
  }

  <label class="mb-4" for="language">{{ 'global.support-select-file-to-send' | translate }}</label>

  <div class="tabs">
    <div *ngFor="let input of fileInputs; let i = index" [class.active]="selectedFileInputId === input.id"
      (click)="selectedFileInputId = input.id">
      {{ 'global.support-button-add-files' | translate }} {{ i + 1 }}
    </div>
    <div class="add-tab" (click)="addFileInput()">
      <i class="material-icons">+</i>
    </div>
  </div>

  <div *ngFor="let input of fileInputs; let i = index">
    <div *ngIf="selectedFileInputId === input.id">
      <input type="file" [id]="'file' + input.id" (change)="onFileSelectedFor(i, $event)" class="custom-file-input" />

      <div class="file-remove">
        <p *ngIf="input.fileName">
          <strong>{{ 'global.support-saved-file' | translate }}: </strong> <span>{{ input.fileName }}</span>
        </p>

        <button type="button" class="btn btn-danger" (click)="removeFileInput(i)" [disabled]="disableButton">
          <i>
            <img src="./../../../../assets/images/support-page/icons/icon-trash-white.svg" alt="icon delete" />
          </i>
        </button>

      </div>
      <div *ngIf="fileExtensionError" class="invalid-feedback">
        <span>{{ 'global.support-error-file-extension-must-be-equal' | translate }}</span>
      </div>
      <div class="form-group mb-5 mt-5">
        <label class="mb-4" for="language">Selecione os idiomas para este arquivo</label>
        <div class="checkbox-group">
          <div *ngFor="let productLang of productLanguages" class="checkbox-item">
            <input type="checkbox" [id]="'lang_' + i + '_' + productLang.code" [value]="productLang.code"
              (change)="onLanguageChangeForFile(i, $event)"
              [checked]="input.selectedLanguages?.includes(productLang.code)" />
            <div class="checkbox-flag">
              <label [for]="'lang_' + i + '_' + productLang.code" class="flag-icon">
                <img [src]="'./../../../../../assets/images/support-page/flags/' + productLang.flag"
                  [alt]="productLang.code" />
                <span class="checkbox-label">{{ productLang.name }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (uploadFormFile.get('productId')?.value !== informativosDocId) {
    <div class="form-group mb-5">
      <select class="form-control" id="category" formControlName="fileCategory">
        <option value="" selected>{{ 'global.support-select-category' | translate }}</option>
        @for (cat of fileCategories; track cat.value) {
          <option [value]="cat.value">{{ cat.label }}</option>
        }
      </select>
      <div *ngIf="uploadFormFile.get('fileCategory')?.invalid && uploadFormFile.get('fileCategory')?.touched"
        class="invalid-feedback">
        {{ 'global.support-select-category-msg-mandatory' | translate }}
      </div>
    </div>

    <div class="form-group mb-5">
      <select class="form-control" id="product" formControlName="productId">
        <option value="" selected>{{ 'global.support-select-product' | translate }}</option>
        <option *ngFor="let product of products" [value]="product.value">
          {{ product.label }}
        </option>
      </select>
      <div *ngIf="uploadFormFile.get('productId')?.invalid && uploadFormFile.get('productId')?.touched"
        class="invalid-feedback">
        {{ 'global.support-select-product-msg-mandatory' | translate }}
      </div>
    </div>
  }

  <div class="form-group mb-5">
    <label class="mb-4" for="date">{{ 'global.support-date' | translate }}</label>
    <input type="date" id="date" class="form-control" formControlName="uploadDate" [ngClass]="{
        'is-invalid': uploadFormFile.get('uploadDate')?.invalid && uploadFormFile.get('uploadDate')?.touched,
      }" />
    <div *ngIf="uploadFormFile.get('uploadDate')?.invalid && uploadFormFile.get('uploadDate')?.touched"
      class="invalid-feedback">
      {{ 'global.support-date-msg-mandatory' | translate }}
    </div>
  </div>

  <div class="buttons mt-5">
    <button class="buttons--btn-cancel" type="button" (click)="closeDialog()">
      <i class="agres-close"></i>
      {{ 'download-support-page.cancel' | translate }}
    </button>

    <button class="buttons--btn-save" type="submit" [disabled]="disableButton || uploadFormFile.invalid"
      [ngClass]="{ 'btn-disabled': disableButton || uploadFormFile.invalid}">
      <i class="agres-upload"></i>
      {{ 'global.save' | translate }}
    </button>
  </div>
</form>